import { Dispatch, ReactElement, SetStateAction, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import NavBar from 'containers/Navigation/NavBar/NavBar';
import { AppState, UserProfile } from 'types';
import { switchUser } from 'store/thunks';

interface LayoutNavBarProps {
  handleNavLinkClick: VoidFunction;
  toggleServerListModal: VoidFunction;
  showAccountDropdown: boolean;
  setShowAccountDropdown: Dispatch<SetStateAction<boolean>>;
}

const LayoutNavBar = (props: LayoutNavBarProps): ReactElement | null => {
  const { handleNavLinkClick, toggleServerListModal, showAccountDropdown, setShowAccountDropdown } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const isAuthenticated = useSelector((state: AppState) => state.auth.isAuthenticated);
  const { postingAs, signedInAs, managedUsers } = useSelector((state: AppState) => state.user);

  const nonPostingUsers: UserProfile[] = managedUsers.concat([signedInAs]);
  // TODO: Check what was this logic about
  // if (postingAs?.FirstName) nonPostingUsers = managedUsers.concat([signedInAs]).filter((user) => user.UserId !== postingAs.UserId);
  // if (signedInAs?.UserId) nonPostingUsers = managedUsers;

  const userPostingAs = postingAs?.FirstName ? postingAs : signedInAs;

  const handleToggleAccountDropdown = useCallback(() => {
    setShowAccountDropdown((prevState) => !prevState);
  }, [setShowAccountDropdown]);

  const handleUserAccountSwitch = useCallback(
    (userId: string) => {
      dispatch(switchUser(userId));
      setTimeout(() => {
        setShowAccountDropdown(false);
      }, 1000);
    },
    [dispatch, setShowAccountDropdown],
  );

  if (location && (location.pathname.includes('/preview') || location.pathname.includes('/posts/'))) return null;

  let navLogoDisabled = false;
  let navLinksHidden = false;
  const isMobile = location.search === '?src=mobileapp';

  if (isAuthenticated && location.pathname === '/verify') navLogoDisabled = true;
  ['/verify', '/add-mobile', '/create-profile', '/password-reset'].forEach((path) => {
    if (location.pathname.includes(path)) navLinksHidden = true;
  });
  ['/add-mobile', '/create-profile', '/password-reset'].forEach((path) => {
    if (location.pathname.includes(path)) navLogoDisabled = true;
  });

  return (
    <NavBar
      isAuthenticated={isAuthenticated}
      profileCreated={signedInAs.ProfileStatus !== 'NotComplete'}
      currentPath={location.pathname}
      handleNavLinkClick={handleNavLinkClick}
      updatePostingAs={handleUserAccountSwitch}
      postingAs={userPostingAs}
      nonPostingUsers={nonPostingUsers}
      toggleServerListModal={toggleServerListModal}
      toggleAccountDropdown={handleToggleAccountDropdown}
      showAccountDropdown={showAccountDropdown}
      show={!isMobile}
      navLinksHidden={navLinksHidden}
      navLogoDisabled={navLogoDisabled}
    />
  );
};

export default LayoutNavBar;
